import withSharedStyles from "../theme/Shared.style";

const withCustomStyles = withSharedStyles(theme => {
  const { color, radius } = theme.tokens;

  return {
    tile: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: 10,
      padding: "8px 0",
      borderRadius: radius.tile,
      color: color.ink,
      textDecoration: "none",
      "&:hover": { color: color.ink }
    },
    disc: {
      width: 84,
      height: 84,
      borderRadius: radius.pill,
      backgroundColor: color.surface,
      overflow: "hidden",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: "background-color .2s ease"
    },
    image: {
      width: "72%",
      height: "72%",
      objectFit: "contain",
      mixBlendMode: "multiply",
      transition: "transform .25s ease"
    },
    name: {
      fontSize: theme.tokens.fontSize.ui,
      fontWeight: 600,
      textAlign: "center",
      lineHeight: 1.25,
      minHeight: 36,
      padding: "0 4px",
      display: "-webkit-box",
      WebkitLineClamp: 2,
      WebkitBoxOrient: "vertical",
      overflow: "hidden",
      transition: "color .15s ease"
    },
    // hover effects go last: JSS resolves $refs only to classes defined above
    // the disc (not the whole tile) reacts, so its edge stays visible
    [theme.media.hover]: {
      tile: {
        "&:hover $disc": { backgroundColor: color.surfaceHover },
        "&:hover $image": { transform: "scale(1.06)" },
        "&:hover $name": { color: color.brandText }
      }
    }
  };
});

export default withCustomStyles;
